import { AvailabilityEnum, CompactAvailability } from '../../../modules/products/ProductTypes';
import { IProductDetailsFiltersToCombinationsParams } from './productDetails.types';

interface MountProductDetailsFilterParamsProps {
  productId: string;
  orderIds?: string[];
  productColorId?: string;
  deliveryWindowIds?: string[];
  allProductColorIds?: string[];
  availability?: AvailabilityEnum | CompactAvailability;
  selectedProductColorId?: string;
  filterByRelatedProducts?: boolean;
  catalogId?: string;
}

export const mountProductDetailsFilterParams = ({
  orderIds,
  catalogId,
  productId,
  availability,
  productColorId,
  deliveryWindowIds,
  allProductColorIds,
  selectedProductColorId,
  filterByRelatedProducts,
}: MountProductDetailsFilterParamsProps): IProductDetailsFiltersToCombinationsParams => {
  return {
    orderIds,
    catalogId,
    productId,
    availability,
    productColorId,
    deliveryWindowIds,
    allProductColorIds,
    selectedProductColorId,
    filterByRelatedProducts,
  };
};
